import React from 'react'
import Main from '../components/ContactPage/Main'

const ContactPage = () => {
  return (
    <div>
        <Main/>
    </div>
  )
}

export default ContactPage